export function pushClickEventToDataLayer(e) {
    if (typeof window !== 'undefined'){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'click', eventTarget: e.target.id });
    }
  }